<template>
  <div>
    <div class="contentFontsPage">
      <h3>Banner blu</h3>
      <MyBanner :text="$t('banner.homePage', { name: 'Ciccio Pagliaccio' })" />
      <p>
        <strong>Colore sfondo:</strong> Gradiente che va da #011930 a #032f5e<br />
        <strong>Colore testo:</strong> #cfd6de<br />
        <strong>Dimensione carattere:</strong> 16px -> 1rem<br />
        <strong>Font:</strong> OpenSansRegular<br />
      </p>
    </div>

    <br /><br />

    <div class="contentFontsPage">
      <h3>Titoli pagine</h3>
      <MyHeaderPage :title="$t('homePage.title')" :subtitle="$t('homePage.subTitle')" :calendar="true" />
      <p>
        <strong>Colore sfondo:</strong> Nessuno<br />
        <strong>Colore calendario:</strong> Nero opacità .87<br />
        <strong>Dimensione calendario:</strong> 16px -> 1rem<br />
        <strong>Font calendario:</strong> OpenSansRegular<br />
        <strong>Colore titolo:</strong> Nero opacità .87<br />
        <strong>Dimensione titolo:</strong> 40px -> 2.5rem<br />
        <strong>Font titolo:</strong> MontserratBold<br />
      </p>
    </div>

    <br /><br />

    <div class="contentFontsPage">
      <h3>Breadcrumbs</h3>
      <div id="Breadcrumbs">
        <div><span class="">Soluzioni</span> <span class="material-icons">chevron_right</span></div>
        <div><span class="">Connettività</span> <span class="material-icons">chevron_right</span></div>
        <div><a href="/verifica-copertura" class="breadUrl">Verifica la Copertura</a> <span
            class="material-icons">chevron_right</span></div>
        <div><span class="last">Nuovo ordine linea</span></div>
      </div>
      <p>
        <strong>Colore sfondo:</strong> Nessuno<br />
        <strong>Colore:</strong> #5f6b7a<br />
        <strong>Dimensione:</strong> 18px -> 1.125rem<br />
        <strong>Font:</strong> OpenSansRegular
      </p>
    </div>

    <br /><br />

    <div class="contentFontsPage">
      <h3>Steps</h3>
      <div class="contentSteps">
        <div class="steps">
          <div class="step complete">
            <div><svg id="Step2" data-name="icon step 02 in corso" xmlns="http://www.w3.org/2000/svg" width="35"
                height="35" viewBox="0 0 35 35">
                <circle id="Ellisse_153" class="setCircle" data-name="Ellisse 153" cx="17.5" cy="17.5" r="17"
                  fill="#e4effc"></circle>
                <g id="lightbulb_black_24dp" transform="translate(8 8)">
                  <g id="Raggruppa_1630" data-name="Raggruppa 1630">
                    <path id="Tracciato_1348" data-name="Tracciato 1348" d="M0,0H19V19H0Z" fill="none"></path>
                  </g>
                  <g id="Raggruppa_1635" data-name="Raggruppa 1635" transform="translate(3.563 1.583)">
                    <g id="Raggruppa_1634" data-name="Raggruppa 1634">
                      <g id="Raggruppa_1631" data-name="Raggruppa 1631" transform="translate(4.354 14.25)">
                        <path id="Tracciato_1349" class="setColor" data-name="Tracciato 1349"
                          d="M11.583,21.583A1.588,1.588,0,0,0,13.167,20H10A1.588,1.588,0,0,0,11.583,21.583Z"
                          transform="translate(-10 -20)" fill="#134c7a"></path>
                      </g>
                      <g id="Raggruppa_1632" data-name="Raggruppa 1632" transform="translate(2.771 11.875)">
                        <path id="Tracciato_1350" class="setColor" data-name="Tracciato 1350"
                          d="M8.792,18.583h4.75a.794.794,0,0,0,.792-.792h0A.794.794,0,0,0,13.542,17H8.792A.794.794,0,0,0,8,17.792H8A.794.794,0,0,0,8.792,18.583Z"
                          transform="translate(-8 -17)" fill="#134c7a"></path>
                      </g>
                      <g id="Raggruppa_1633" data-name="Raggruppa 1633">
                        <path id="Tracciato_1351" class="setColor" data-name="Tracciato 1351"
                          d="M10.438,2A5.934,5.934,0,0,0,7.485,13.083H13.39A5.934,5.934,0,0,0,10.438,2Z"
                          transform="translate(-4.5 -2)" fill="#134c7a"></path>
                      </g>
                    </g>
                  </g>
                </g>
              </svg></div>
            <div>
              <p class="nameStep">1. Opzioni aggiuntive</p><!--v-if-->
            </div>
          </div>
          <div class="spacing"></div>
          <div class="step active">
            <div><svg id="Step3" data-name="icon step 03 in corso" xmlns="http://www.w3.org/2000/svg" width="35"
                height="35" viewBox="0 0 35 35">
                <circle id="Ellisse_153" class="setCircle" data-name="Ellisse 153" cx="17.5" cy="17.5" r="17"
                  fill="#e4effc"></circle>
                <g id="inventory_black_24dp" transform="translate(8 8)">
                  <g id="Raggruppa_1636" data-name="Raggruppa 1636">
                    <rect id="Rettangolo_2404" data-name="Rettangolo 2404" width="19" height="19" fill="none"></rect>
                  </g>
                  <g id="Raggruppa_1638" data-name="Raggruppa 1638" transform="translate(2.375 0.792)">
                    <g id="Raggruppa_1637" data-name="Raggruppa 1637">
                      <path id="Tracciato_1352" class="setColor" data-name="Tracciato 1352"
                        d="M4.583,4.167H6.167v.792A1.588,1.588,0,0,0,7.75,6.542H12.5a1.588,1.588,0,0,0,1.583-1.583V4.167h1.583V8.125H17.25V4.167a1.588,1.588,0,0,0-1.583-1.583H12.358a2.366,2.366,0,0,0-4.465,0H4.583A1.588,1.588,0,0,0,3,4.167V15.25a1.588,1.588,0,0,0,1.583,1.583h4.75V15.25H4.583Zm5.542-1.583a.792.792,0,1,1-.792.792A.794.794,0,0,1,10.125,2.583Z"
                        transform="translate(-3 -1)" fill="#134c7a"></path>
                      <path id="Tracciato_1353" class="setColor" data-name="Tracciato 1353"
                        d="M19.6,12.186a.846.846,0,0,0-1.187,0l-3.752,3.76-1.789-1.781a.846.846,0,0,0-1.187,0h0a.846.846,0,0,0,0,1.188L14.1,17.759a.788.788,0,0,0,1.116,0l4.378-4.386A.839.839,0,0,0,19.6,12.186Z"
                        transform="translate(-4.759 -3.28)" fill="#134c7a"></path>
                    </g>
                  </g>
                </g>
              </svg></div>
            <div>
              <p class="nameStep">2. Riferimenti</p><!--v-if-->
            </div>
          </div>
          <div class="spacing"></div>
          <div class="step">
            <div><svg id="Step4" data-name="icon step 04 in corso" xmlns="http://www.w3.org/2000/svg" width="35"
                height="35" viewBox="0 0 35 35">
                <circle id="Ellisse_153" class="setCircle" data-name="Ellisse 153" cx="17.5" cy="17.5" r="17"
                  fill="#e4effc"></circle>
                <g id="info_black_24dp" transform="translate(8 8)">
                <path id="Tracciato_1354" data-name="Tracciato 1354" d="M0,0H19V19H0Z" fill="none"></path>
                <path id="Tracciato_1355" class="setColor" data-name="Tracciato 1355"
                  d="M9.917,2a7.917,7.917,0,1,0,7.917,7.917A7.92,7.92,0,0,0,9.917,2Zm0,11.875a.794.794,0,0,1-.792-.792V9.917a.792.792,0,0,1,1.583,0v3.167A.794.794,0,0,1,9.917,13.875Zm.792-6.333H9.125V5.958h1.583Z"
                  transform="translate(-0.417 -0.417)" fill="#134c7a"></path>
              </g>
            </svg></div>
          <div>
            <p class="nameStep">3. Account Radius</p><!--v-if-->
          </div>
        </div>
        <div class="spacing"></div>
        <div class="step">
          <div><svg id="Step5" data-name="icon step 05 in corso" xmlns="http://www.w3.org/2000/svg" width="35"
              height="35" viewBox="0 0 35 35">
              <circle id="Ellisse_153" class="setCircle" data-name="Ellisse 153" cx="17.5" cy="17.5" r="17"
                fill="#e4effc"></circle>
              <g id="account_tree_black_24dp" transform="translate(8 8)">
                <rect id="Rettangolo_2407" data-name="Rettangolo 2407" width="19" height="19" fill="none"></rect>
                <path id="Tracciato_1356" class="setColor" data-name="Tracciato 1356"
                  d="M13.875,9.333H16.25A1.583,1.583,0,0,0,17.833,7.75V4.583A1.583,1.583,0,0,0,16.25,3H13.875a1.583,1.583,0,0,0-1.583,1.583v.792H7.55V4.583A1.583,1.583,0,0,0,5.966,3H3.583A1.588,1.588,0,0,0,2,4.583V7.75A1.583,1.583,0,0,0,3.583,9.333H5.958A1.583,1.583,0,0,0,7.542,7.75V6.958H9.125v5.55a2.368,2.368,0,0,0,2.367,2.367h.8v.792a1.583,1.583,0,0,0,1.583,1.583H16.25a1.583,1.583,0,0,0,1.583-1.583V12.5a1.583,1.583,0,0,0-1.583-1.583H13.875A1.583,1.583,0,0,0,12.292,12.5v.792h-.8a.791.791,0,0,1-.784-.784V6.958h1.583V7.75A1.588,1.588,0,0,0,13.875,9.333Z"
                  transform="translate(-0.417 -0.625)" fill="#134c7a"></path>
              </g>
            </svg></div>
          <div>
            <p class="nameStep">4. Info Aggiuntive</p><!--v-if-->
          </div>
        </div>
        <div class="spacing"></div>
        <div class="step">
          <div><svg id="Step6" data-name="icon step 06 in corso" xmlns="http://www.w3.org/2000/svg" width="35"
              height="35" viewBox="0 0 35 35">
              <circle id="Ellisse_153" class="setCircle" data-name="Ellisse 153" cx="17.5" cy="17.5" r="17"
                fill="#e4effc"></circle>
              <g id="privacy_tip_black_24dp" transform="translate(8 8)">
                <rect id="Rettangolo_2409" data-name="Rettangolo 2409" width="19" height="19" fill="none"></rect>
                <path id="Tracciato_1357" class="setColor" data-name="Tracciato 1357"
                  d="M3.942,3.786A1.59,1.59,0,0,0,3,5.235V8.956a9.852,9.852,0,0,0,7.125,9.5,9.852,9.852,0,0,0,7.125-9.5V5.235a1.59,1.59,0,0,0-.942-1.449L10.766,1.324a1.574,1.574,0,0,0-1.282,0Zm6.183,2h0a.794.794,0,0,1,.792.792h0a.794.794,0,0,1-.792.792h0a.794.794,0,0,1-.792-.792h0A.794.794,0,0,1,10.125,5.789Zm0,3.167h0a.794.794,0,0,1,.792.792v3.167a.794.794,0,0,1-.792.792h0a.794.794,0,0,1-.792-.792V9.747A.794.794,0,0,1,10.125,8.956Z"
                  transform="translate(-0.625 -0.247)" fill="#134c7a"></path>
              </g>
            </svg></div>
          <div>
            <p class="nameStep">5. Migrazione Olo2Olo</p>
          </div>
        </div>
      </div>
    </div>
    <p>
      <strong>Colore sfondo:</strong> Nessuno<br />
      <strong>Colore step completato:</strong> #3caea3<br />
      <strong>Colore step in corso:</strong> #002e5f<br />
      <strong>Colore step non attivo:</strong> #8895a7<br />
      <strong>Dimensione:</strong> 16px -> 1rem<br />
      <strong>Font:</strong> OpenSansSemiBold
    </p>
  </div>

  <br /><br />

  <div class="contentFontsPage">
    <h3>Box riepilogo</h3>
    <div id="OrderNetworkCoverage">
      <div class="contentForm">
        <div class="contentPrimary pink"><img
            src="data:image/png;base64,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"
            alt="icon" width="45">
          <p class="label">Soluzione in attivazione</p>
          <p class="text">FTTH OF 1000/300</p>
          <p><span class="labelS">Tecnologia</span> <span class="textS">FTTH</span><span class="labelS">Carrier</span>
            <span class="textS">OPEN FIBER</span></p>
          <hr><img
            src="data:image/png;base64,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"
            alt="location" width="45"><!-- <span class="material-icons locationIcon">location_on</span> -->
          <p class="label">Indirizzo</p>
          <p class="text">VIALE MONZA 1 MILANO MI</p>
        </div>
      </div>
      <br />
    </div>
    <p>
      <strong>Colore sfondo:</strong> dipende dal form<br />
      <strong>Colore label:</strong> #134c7a<br />
      <strong>Dimensione label:</strong> 18px -> 1.125rem<br />
      <strong>Font label:</strong> OpenSansRegular<br /><br />
      <strong>Colore valore:</strong> #002e5f<br />
      <strong>Dimensione valore:</strong> 18px -> 1.125rem / 20px -> 1.25rem<br />
      <strong>Font valore:</strong> OpenSansBold
    </p>
  </div>

  <br /><br />

  <div class="contentFontsPage">
    <h3>Forms</h3>
    <div id="OrderNetworkCoverage">
      <div class="contentForm">
        <div class="contentSecondary">
          <div kit="[object Object]"><!--v-if--><h2>Riferimenti*</h2><!--v-if--><div class="mdl-grid"><div class="mdl-cell mdl-cell--4-col"><span class="labelOne marginLeft8"><br></span><select class="endConsumer" name="end_customer"><option value="">Seleziona</option><option value="9999">Non in lista</option><option value="3">Esempio</option></select><!--v-if--></div><div class="mdl-cell mdl-cell--4-col"><div class="cdl-input"><input type="text" name="endCustomerVatId" id="endCustomerVatId" maxlength="255" class="not-empty" value="Prova"><label>Partita IVA</label><!--v-if--></div></div><div class="mdl-cell mdl-cell--4-col"><div class="cdl-input"><input type="text" name="endCustomerVatCf" id="endCustomerVatCf" maxlength="255"><label>Codice fiscale</label><!--v-if--></div></div><!--v-if--></div><hr><div class="mdl-grid"><div class="mdl-cell mdl-cell--12-col"><span class="labelTwo">Referente tecnico*</span></div><div class="mdl-cell mdl-cell--6-col"><div class="cdl-input noMargin"><input type="text" name="technicalName" id="technicalName" maxlength="255" class=""><label>Nome e cognome</label><span class="error">Nome e cognome del tecnico è un campo obbligatorio.</span></div></div><div class="mdl-cell mdl-cell--6-col"></div></div>
          <hr><div class="mdl-grid"><div class="mdl-cell mdl-cell--12-col"><label class="labelOne">Vuoi aggiornare il cliente in rubrica?</label></div><div class="mdl-cell mdl-cell--1-col"><p class="labelSwitch onNo">NO</p></div><div class="mdl-cell mdl-cell--1-col"><label class="switch"><input type="checkbox" class="not-empty"><span class="slider round"></span></label></div><div class="mdl-cell mdl-cell--1-col"><p class="labelSwitch">SI</p></div></div><!--v-if--></div>
        </div>
      </div>
    </div>
    <p>

      <strong>Colore titolo:</strong> #002e5f<br />
      <strong>Dimensione titolo:</strong> 35px -> 2.188rem<br />
      <strong>Font titolo:</strong> MontserratSemiBold<br /><br />

      <strong>Dimensione input:</strong> 16px -> 1rem<br />
      <strong>Font input:</strong> OpenSansRegular<br /><br />
      <strong>Colore sfondo input:</strong> #f8f9fa<br /><br />

      <strong>Colore label riposo:</strong> #b0b0b0<br />
      <strong>Dimensione label riposo:</strong> 16px -> 1rem<br />
      <strong>Font label riposo:</strong> OpenSansRegular<br /><br />

      <strong>Colore label attiva:</strong> #002e5f<br />
      <strong>Dimensione label attiva:</strong> 16px -> 1rem<br />
      <strong>Font label attiva:</strong> OpenSansRegular<br /><br />

      <strong>Colore errore:</strong> #d60812<br />
      <strong>Dimensione errore:</strong> 16px -> 1rem<br />
      <strong>Font errore:</strong> OpenSansSemiBold<br /><br />

      <strong>Colore titoletto:</strong> #b8c4ce<br />
      <strong>Dimensione titoletto:</strong> 20.8px -> 1.3rem<br />
      <strong>Font titoletto:</strong> OpenSansSemiBold<br /><br />

      <strong>Colore label switch:</strong> #002e5f<br />
      <strong>Dimensione label switch:</strong> 20.8px -> 1.3rem<br />
      <strong>Font label switch:</strong> OpenSansSemiBold
    </p>
  </div>

  <br /><br />

  <div class="contentFontsPage">
    <h3>Modale</h3>
    <div id="MyModal" style="position: unset; padding-bottom: 50px;">
      <div class="contentModal open"><!--v-if--><h3>Richiesta inoltrata con successo!</h3><p class="sub">Hai confermato la tua consegna per il Data Center C21 - Milano.</p><p class="text">La tua richiesta sarà disponibile a breve nell'area ticket.</p><div class="contentButton"><button id="btnModal" class="cdlButtonGreen">Vai all’area ticket</button><br><br><div><p class="deleteOrder" id="deleteOrder">Prenota nuova consegna</p></div></div></div>
    </div>
    <p>
      <strong>Larghezza:</strong> 350px;<br />
      <strong>Colore sfondo:</strong> rgba(207, 214, 222, 0.9);<br /><br />

      <strong>Colore titolo:</strong> #001831<br />
      <strong>Dimensione titolo:</strong> 40px -> 2.5rem<br />
      <strong>Font titolo:</strong> MontserratBold<br /><br />

      <strong>Colore testo 1:</strong> #5f6b7a<br />
      <strong>Dimensione testo 1:</strong> 18px -> 1.125rem<br />
      <strong>Font testo 1:</strong> OpenSansRegular<br /><br />

      <strong>Colore testo 2:</strong> #002e5f<br />
      <strong>Dimensione testo 2:</strong> 18px -> 1.125rem<br />
      <strong>Font testo 2:</strong> OpenSansBold
    </p>
  </div>

    <br /><br />

    <div class="contentFontsPage">
      <h3>Bottone</h3>
      <div class="contentButton" data-v-212e4410=""><button id="btnModal" class="cdlButtonGreen" data-v-212e4410="">Vai all’area ticket</button><br data-v-212e4410=""><br data-v-212e4410=""><div data-v-212e4410=""><p class="deleteOrder" id="deleteOrder" data-v-212e4410="">Prenota nuova consegna</p></div></div>
      <p>
        <strong>Dimensione tasto verde/blu:</strong> 16px -> 1rem<br />
        <strong>Font tasto verde/blu:</strong> OpenSansBold<br /><br />

        <strong>Dimensione tasto Annulla:</strong> 16px -> 1rem<br />
        <strong>Colore tasto Annulla:</strong> Nero opacità .87
      </p>
    </div>

</div>
</template>


<script>
import MyBanner from '@/components/MyBanner.vue'
import MyHeaderPage from '@/components/MyHeaderPage.vue'

export default {
  name: "CdlFonts",
  components: {
    MyBanner,
    MyHeaderPage
  },
  data() {
    return {

    };
  },
  methods: {

  },
  mounted() {
    window.scrollTo(0, 0);

  },
};
</script>

<style scoped>.contentFontsPage {
  background-color: white;
  padding: 20px;
  border-radius: 6px;
  box-shadow: 0px 1px 3px #3d3d3d1a;
}</style>
